import { forwardRef as t, createElement as i } from "react";
import f from "classnames";
import { VIEW_RENDER_AS as l } from "./index169.mjs";
import p from "./index260.mjs";
const c = t(
  ({ as: e = l.DIV, children: m, classes: r, style: o, ...a }, s) => i(
    e,
    {
      style: o,
      className: f([p.view, r]),
      ref: s,
      ...a
    },
    m
  )
);
c.displayName = "View";
export {
  l as VIEW_RENDER_AS,
  c as View,
  c as default
};
